export default {
    backgroundProcess: [],
    type: '',
    is_global_report: false,
    measures: [
        {
            value: 'A',
            text: 'Verticales ET Pequeña (Aprox 5x6cm - 5x7cm)',
        },
        {
            value: 'B',
            text: 'Verticales ET Mediana (Aprox 7x10cm - 7x12cm)',
        },
        {
            value: "C",
            text: "Verticales ET Grande (Aprox 18x12cm)",
        },
        {
            value: "D",
            text: "Verticales ET Extra-Grande (Aprox 22x18cm)",
            multiple: [],
        },
        {
            value: "E",
            text: "Resolución 0773 ET Pequeña (Aprox 7.4X5.2cm - 7.5x6cm)",
        },
        {
            value: "F",
            text: "Resolución 0773 ET Mediana (Aprox 10.5X7.4cm - 10.8X7.6cm)",
        },
        {
            value: "G",
            text: "Resolución 0773 ET Grande (Aprox 14.8x10.5cm)",
        },
        {
            value: "H",
            text: "Resolución 0773 ET Extra-Grande (Aprox 21x14.8cm)",
        },
        {
            value: "I",
            text: "Halliburton ET Pequeña (Aprox 10.8X4.65cm)",
        },
        {
            value: "J",
            text: "Halliburton ET Mediana (Aprox 14X10.5cm)",
        },
        {
            value: "K",
            text: "Halliburton ET Grande (Aprox 21.5x14cm)",
        },
        {
            value: "Etq_3x4_5_Micro",
            text: "Baker Etq 3 x 4.5 Micro",
        },
        {
            value: "Etq_7_4x5_2_Pequeña",
            text: "Baker Etq 7,4 x 5,2 Pequeña",
        },
        {
            value: "Etq_7_4x10_5_Mediana",
            text: "Baker Etq 7,4 x 10,5 Mediana",
        },
        {
            value: "Etq_14_5x10_5_Grande",
            text: "Baker Etq 14.5 x 10,5 Grande",
        },
        {
            value: "Etq_21_x14_8_Extra_Grande",
            text: "Baker Etq 21 x 14.8  Extra-Grande",
        },
        {
            value: "N",
            text: "Verticales ET Mini (Aprox 2x4.5cm)",
        },
        {
            value: "O",
            text: "Resolución 0773 ET Micro (Aprox 3X3.5cm)",
        },
    ]
}
